import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=a0465be8&scoped=true&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=a0465be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0465be8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0465be8')) {
      api.createRecord('a0465be8', component.options)
    } else {
      api.reload('a0465be8', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=a0465be8&scoped=true&", function () {
      api.rerender('a0465be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vab/form/checkbox.vue"
export default component.exports